<template>

    <form ref="instituicaoensinoestagio-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
                    <div class="form-group col-md-12">
                        <label for="estagioId">Estágio</label>
                        <select v-select="{ dataitem: 'Estagio', default: 'Selecione', filters: { attributeBehavior: 'EstagioAtivo' } }" v-model="model.estagioId" class="form-control" name="estagioId" required></select>
                    </div>
					<div class="form-group col-md-12">
                        <div class="clearfix">&nbsp;</div>
                        <label class="custom-control custom-checkbox">
                            <input type="checkbox" name="vendaLiberada" class="custom-control-input" v-model="model.vendaLiberada">
                            <span class="custom-control-indicator"></span>
                            <span class="custom-control-description"> Venda Liberada?</span>
                        </label>
                    </div>
                    <div class="form-group col-md-12">
                        <label for="valorMaterialDidaticoInstituicao">Valor Material Didático Instituição</label>
                        <money v-bind="money" class="form-control" name="valorMaterialDidaticoInstituicao" placeholder="ValorMaterialDidaticoInstituicao" v-model="model.valorMaterialDidaticoInstituicao" required />

                    </div>
                    <div class="form-group col-md-12">
                        <label for="valorMaterialDidaticoAluno">Valor Material Didático Aluno</label>
                        <money v-bind="money" class="form-control" name="valorMaterialDidaticoAluno" placeholder="ValorMaterialDidaticoAluno" v-model="model.valorMaterialDidaticoAluno" required />
                    </div>


        </div>

        <button type="button" class="btn btn-default" @click="onBack()">
            <span>Voltar</span>
        </button>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>

    </form>


</template>
<script>
    
	import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "instituicaoensinoestagio-form-create",
        mixins: [base],
        props: { id: Number },
        data: () => ({

            model: {},

            form: "instituicaoensinoestagio-form-create",
            
            resources: {
                create: 'instituicaoensinoestagio',
            },

        }),
		
        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                this.model.instituicaoEnsinoId = this.$props.id;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

